export enum ServiceType {
  DineIn = "DINE_IN",
  Pickup = "PICKUP",
  ALL = "ALL",
}
